"use client";
import { cn } from "@/lib/utils";
import DOMPurify from "dompurify";
import { marked } from "marked";

interface HtmlContentProps {
  content: string;
  className?: string;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ content, className }) => {
  // Convert Markdown to HTML and sanitize it
  const rawMarkup = marked.parse(content);
  const sanitizedContent = DOMPurify.sanitize(rawMarkup as string);

  return (
    <div
      className={cn(className)}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default HtmlContent;
